












import { useResult } from '@vue/apollo-composable';
import { defineComponent, watch } from '@vue/composition-api';
import Navigationbar from './components/Navigationbar.vue';
import useGlobalLoading from './composables/useGlobalLoading';
import useOidc from './composables/useOidc';
import useProfile from './composables/useProfile';
import { useGetProfileQuery } from './graphql/types';
import Splash from './components/Splash.vue';
export default defineComponent({
  components: { Navigationbar, Splash },
  setup(_, { root }) {
    const { user } = useOidc();
    const profileQuery = useGetProfileQuery(() => ({
      enabled: user.value != null
    }));

    const { setProfile } = useProfile();

    watch(
      () => useResult(profileQuery.result).value,
      newValue => {
        setProfile(newValue);
      },
      { immediate: true }
    );

    return {
      isLoading: useGlobalLoading().isLoading
    };
  }
});
